import { useEffect, useState } from 'react';
import { Table, Card, Select, Button, message, Typography, Tag, Space, Image } from 'antd';
import api from '../../api/axios';

const { Title } = Typography;
const BASE = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const STATUS = { pending: { t: 'Kutilmoqda', c: 'orange' }, reviewed: { t: "Ko'rildi", c: 'blue' }, resolved: { t: 'Hal qilindi', c: 'green' }, rejected: { t: 'Rad etildi', c: 'red' } };

export default function GovReportsPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (statusFilter) params.status = statusFilter;
      const r = await api.get('/admingov/reports', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(1); }, []);
  useEffect(() => { fetchData(1); }, [statusFilter]);

  const changeStatus = async (id, status) => {
    try {
      await api.put(`/admingov/reports/${id}`, { status });
      message.success('Yangilandi'); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: 'Vendor nomi', dataIndex: 'vendor_name' },
    { title: 'Xizmat turi', dataIndex: 'service_type_name' },
    { title: 'Viloyat', dataIndex: 'region' },
    { title: 'Tafsilot', dataIndex: 'details', ellipsis: true },
    { title: 'Telefon', dataIndex: 'reporter_phone' },
    {
      title: 'Dalillar', dataIndex: 'evidence',
      render: (ev) => ev?.length ? (
        <Image.PreviewGroup>
          <Space>{ev.map((e, i) => <Image key={i} width={40} src={`${BASE}/${e.file_path}`} />)}</Space>
        </Image.PreviewGroup>
      ) : '-'
    },
    {
      title: 'Status', dataIndex: 'status',
      render: (s, r) => (
        <Select size="small" value={s} onChange={v => changeStatus(r.id, v)} style={{ width: 120 }}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v.t, value: k }))} />
      )
    },
    { title: 'Sana', dataIndex: 'created_at', render: v => v ? new Date(v).toLocaleDateString('uz-UZ') : '-' },
  ];

  return (
    <div>
      <Title level={3}>Shikoyatlar boshqaruvi</Title>
      <Card style={{ borderRadius: 12, marginBottom: 16 }}>
        <Select placeholder="Status" allowClear style={{ width: 180 }} value={statusFilter} onChange={setStatusFilter}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v.t, value: k }))} />
      </Card>
      <Card style={{ borderRadius: 12 }}>
        <Table
          dataSource={data} columns={columns} rowKey="id" loading={loading} size="small" scroll={{ x: 900 }}
          pagination={{ current: page, total, pageSize: 20, onChange: p => { setPage(p); fetchData(p); } }}
        />
      </Card>
    </div>
  );
}
